import { findIndex, clone } from 'lodash';
import { MOVE_ITEM } from '../../../graphql/shopping-list';
import { UndoAction } from './Action';

/* eslint-disable no-underscore-dangle */

class MoveItemAction extends UndoAction {
  constructor(options) {
    super(options);

    if (options.drag) {
      if (options.drag.active !== options.itemListName) {
        throw new Error('Why is this being called, drag is not set');
      }

      const draggedContext = options.drag.evt.draggedContext;
      this.itemId = draggedContext.element.id;
      this.index = draggedContext.index;
      this.newIndex = draggedContext.futureIndex;
    }

    this.itemListName = options.itemListName;
    this.value = options.value;
  }

  static get name() { return 'MoveItemAction'; }

  _executeImpl() {
    const self = this;

    return this.component.$apollo.mutate({
      mutation: MOVE_ITEM,
      variables: {
        id: this.component.shoppingList.id,
        itemId: this.itemId,
        newIndex: this.newIndex,
        itemListName: this.itemListName,
      },
      update(store, { data: { shoppingListMoveItem } }) {
        self._updateCache(store, shoppingListMoveItem);
      },
      optimisticResult: {
        shoppingListMoveItem: {
          /* eslint-disable no-underscore-dangle */
          __typename: 'ShoppingListMoveItemResult',
          list: self.value,
          modifiedAt: null,
        },
      },
    });
  }

  updateQuery(cachedShoppingList, shoppingListMoveItemResult) {
    cachedShoppingList.items[this.itemListName] = shoppingListMoveItemResult.list;
    return cachedShoppingList;
  }

  undo() {
    const currentList = this.component.shoppingList.items[this.itemListName];
    const index = findIndex(currentList, { id: this.itemId });
    if (index < 0) {
      throw new Error('Undo move item failed, item not found.');
    }

    if (index !== this.newIndex) {
      /* eslint-disable no-console */
      console.error(`Not good, item found at index ${index}, expected ${this.newIndex}`);
    }

    // Create item list with items in the order prior to the move
    const priorItemList = [];
    currentList.forEach((item, itrIndex) => {
      if (itrIndex === this.index) {
        priorItemList.push(clone(currentList[this.newIndex]));
      } else if (itrIndex !== this.newIndex) {
        priorItemList.push(clone(item));
      }
    });

    // Create new drag context to resuse logic expecting drag-and-drop
    const drag = {
      active: this.itemListName,
      evt: {
        draggedContext: {
          element: {
            id: this.itemId,
          },
          futureIndex: this.index,
          index: this.newIndex,
        },
      },
    };

    return this.component.triggerAction(MoveItemAction, {
      itemListName: this.itemListName,
      value: priorItemList,
      drag,
      undoAction: this,
    });
  }

  updateItem(oldItem, newItem) {
    if (this.itemId === oldItem.id) {
      this.itemId = newItem.id;
    }
  }

  // eslint-disable-next-line
  undoTooltip() { return 'Undo move item'; }

  // eslint-disable-next-line
  redoTooltip() { return 'Redo move item'; }
}

export default MoveItemAction;



// WEBPACK FOOTER //
// ./src/components/shopping-list/actions/MoveItemAction.js